
import { ProfilAssetType } from "../validations";
import { DataAssetType } from "../../types";


export const defaultValueProfil = (value: Partial<DataAssetType> = {}): ProfilAssetType => ({
    divisi_id: value.divisi_id || "",
    department_id: value.department_id || "",
    employee_id: value.employee_id || "",
    warranty_period: value.warranty_period || "",
    warranty_expired: value.warranty_expired || null,
    insured: value.insured || "",
    insurance_policy: value.insurance_policy || "",
    insurance_expired: value.insurance_expired || "",
    coa_asset_id: value.coa_asset_id || "",
    coa_depreciation_id: value.coa_depreciation_id || "",
    coa_disposal_id: value.coa_disposal_id || "",
    asset_profile_id: value.asset_profile_id || "",
});
